import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import React from "react";
import ModalComponent from "../ModalComponent";
import GlobalStyles from "../../globalStyles/globalStyles";
import { Colors } from "../../globalStyles/ColorConfig";
import { updateData } from "../../services/Profile/profileService";
import { PROFILE_ROUTES } from "../../navigation/routes";
import { RootState, useSelector } from "../../redux/store";
import { useNavigation } from "@react-navigation/native";

interface AgeProps {
  isVisible: boolean;
  toggleModal: () => void;
  age: Number;
  dob: any;
}
function month(month: String) {
  if (month == "01") return "January";
  if (month == "02") return "February";
  if (month == "03") return "March";
  if (month == "04") return "April";
  if (month == "05") return "May";
  if (month == "06") return "June";
  if (month == "07") return "July";
  if (month == "08") return "August";
  if (month == "09") return "September";
  if (month == "10") return "October";
  if (month == "11") return "November";
  if (month == "12") return "December";
}

export default function AgeModal({
  isDialog = false,
  isVisible,
  toggleModal,
  age,
  dob,
}: {
  isDialog?: boolean;
  isVisible: any;
  toggleModal: any;
  age: Number;
  dob: any;
}) {
  const { userToken } = useSelector((state: RootState) => state.user);
  const navigation = useNavigation();

  const handleConfirm = async () => {
    const updateUser = {
      age: age,
      dateOfBirth: new Date(dob[2], dob[1], dob[0]),
      steps: 2,
    };
    const response = await updateData(updateUser);
    navigation.navigate(PROFILE_ROUTES.ONBOARD_GENDER as never);
  };
  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View
        style={{
          justifyContent: "center",
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Background layer color
          width: "100%",
          height: "100%",
          position: "absolute",
          alignItems: "center",
        }}
      >
        <View style={[styles.modalWrap,{
          paddingTop:30
        }]}>
          <Text
            style={[
              GlobalStyles.heading2,
              { 
                fontSize: 36,
                fontFamily: "EBGaramondSemiBold",
                lineHeight: 37,
                letterSpacing: -0.3,
                paddingLeft:16
              },
            ]}
          >
            You’re {age.toString()}
          </Text>
          <Text
            style={[
              { 
                fontFamily: "EBGaramondSemiBold",
                fontSize: 16,
                lineHeight: 22,
                paddingLeft:16,
                letterSpacing: -0.3,
                color: "#707070",
              },
            ]}
          >
            Born {month(dob[1])} {dob[0]}, {dob[2]}
          </Text>
          <Text
            style={[GlobalStyles.bodyText, { fontSize:14,fontFamily:"InterMedium", letterSpacing:-0.36, lineHeight:22, color:"rgba(0,0,0,0.7)",
            paddingTop:25,
            paddingHorizontal:16
             }]}
          >
            Confirm your age is correct. Let’s keep our community authentic
          </Text>
          <View style={styles.ModalButtonWrap}>
            <TouchableOpacity
              onPress={toggleModal}
              style={[styles.ModalButton, styles.ModalSecondaryButton]}
            >
              <Text
                style={[GlobalStyles.title2, styles.ModalSecondaryButtonText,{
                  fontSize:14,
                  letterSpacing:-0.4,
                  fontFamily:"InterMedium"
                }]}
              >
                Edit
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.ModalButton, styles.ModalPrimaryButton]}
              onPress={() => {
                handleConfirm();
                toggleModal();
              }}
            >
              <Text
                style={[
                  GlobalStyles.title2,
                  styles.ModalButtonText,
                  styles.ModalPrimaryButtonText,
                 ,{
                  fontSize:14,
                  letterSpacing:-0.4,
                  fontFamily:"InterMedium"
                 }
                ]}
              >
                Confirm
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </ModalComponent>
  );
}
const styles = StyleSheet.create({
  modalBackground: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.4)", // Background layer color
  },
  ModalPrimaryButton: {
    backgroundColor: Colors.darkGreen,
  },
  ModalSecondaryButton: {},
  ModalSecondaryButtonText: {},
  ModalButtonText: {},
  ModalPrimaryButtonText: {
    color: "#fff",
    fontSize: 16,
  },
  modalWrap: {
    backgroundColor: "white",
    width: "92%",
    overflow: "hidden",
    borderRadius: 8,
  },
  ModalButton: {
    borderWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.2)",
    // marginRight: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    paddingVertical: 15,
  },
  ModalButtonWrap: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 20,
    width: "100%",
  },
  containerBtnText: {
    fontSize: 16,
    color: "#000",
    textAlign: "center",
  },
  btnPrimary: {
    backgroundColor: "#D9D9D9",
    borderRadius: 4,
  },
  containerBtn: {
    width: "100%",
    paddingVertical: 20,
    marginTop: 40,
    textAlign: "center",
  },

  modalHeader: {
    fontSize: 26,
    fontWeight: "bold",
    textAlign: "left",
  },
  modalContainer: {
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
    position: "absolute",
    top: "35%",
    alignItems: "center",
  },
  modalSubtitle: {
    fontSize: 16,
    marginTop: 6,
    color: "#707070",
  },
});
